import { render, staticRenderFns } from "./NovaBreadcrumb.vue?vue&type=template&id=75597888&scoped=true&lang=pug&"
import script from "./NovaBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./NovaBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./NovaBreadcrumb.vue?vue&type=style&index=0&id=75597888&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75597888",
  null
  
)

export default component.exports